export default __webpack_public_path__ + "static/media/calendar-DE.cafc7a57.png";